import React, { useState, useCallback, useMemo, useEffect } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import Typography from '@mui/material/Typography';
import EditTable from './EditTable';
import { TextField } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import Loading from '../../Loading';
import { makeStyles } from '@material-ui/core/styles';
import AlertService from '../../../../services/console_services/Alerts';
import { connect } from 'react-redux';
import { useSelector } from 'react-redux';

const useStyles = makeStyles({
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh',
    width: '100%',
    position: 'relative',
    top: 0,
    left: 0,
  },
});

const BootstrapDialog = styled(Dialog)(({ _theme }) => ({
  '& .MuiDialog-paper': {
    width: '80%',
    maxWidth: 'none',
    // minHeight: "600px",
    borderRadius: 12,
    height: "470px"
  },
}));

const EditAlerts = ({
  openEdit,
  handleEditClose,
  handleBulkEdit,
  _payloadIncrease,
  _costReduction,
  _payloadDecrease,
  Network,
  DC,
  role,
  onSave,
  setOnsave,
  fileData,
  editAlertLoading, 
  setEditAlertLoading
}) => {
  const classes = useStyles();
  const { instance } = useMsal();

  const { tabName } = useSelector((state) => state?.tabs);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [unsavedChanges, setUnsavedChanges] = useState(true);
  const [editThresholdAlertsData, setEditThresholdAlertsData] = useState([]);
  //const [editAlertLoading, setEditAlertLoading] = useState(false);
  const [updatedRowsWithThresholdValues, setUpdatedRowsWithThresholdValues] = useState([]);
  var apiValues = tabName;

  if (tabName === 'Deployment Optimization') {
    apiValues = "DO";
  } else if (tabName === 'Deployment Planning') {
    apiValues = "DP";
  } else if (tabName === 'FG Salvage' || tabName === 'FGS') {
    apiValues = "FGS";
  } else if (tabName === 'Capacity Planning' || tabName === 'CP') {
    apiValues = "CP";
  }else if (tabName === 'Distribution_Planning') {
    apiValues = "DIP";
  }else if (tabName === 'Potential Out Of Stock') {
    apiValues = "POOS";
  }else if (tabName === 'RR') {
    apiValues = "RR";
  }else if (tabName === 'Network Planning Simulation') {
    apiValues = "NPS";
  }

  const updateThresholdValues = (rowData) => {
    const params = {
      "alertDetailsArray": rowData,
      "Level": role,
      "module": apiValues,
      "filter": {}
    };
    if (Network !== "") {
      params.filter.Network = Network;
    } else if (DC !== "") {
      params.filter.RecommendedDC = DC;
    }
    // if (Object.keys(filter).length) {
    //   params.filter = filter
    // }
    setEditAlertLoading(true);
    AlertService.updateThresholdValues(params, instance).then(_data => {
      getEditThresholdAlertData();
    })
    .catch(error => console.error('Error:', error))
    .finally(()=> setOnsave(true));
  };



  const getEditThresholdAlertData = () => {
    setEditAlertLoading(true);
    const params = {
      module: apiValues
    };
    AlertService.getEditThresholdAlerts(params, instance).then(data => {
      if (data?.data) {
        setEditThresholdAlertsData(data?.data);
      }
    })
      .catch(error => console.error('Error:', error))
      .finally(() => setEditAlertLoading(false));
  };

  useEffect(() => {
    getEditThresholdAlertData();
  }, [tabName, Network, DC]);

  useEffect(() => {
    if (onSave === true) {
      getEditThresholdAlertData();
    }
  }, [onSave]);


  const filteredRows = useMemo(() => {
    const augmentedData = fileData.map((row) => {
      let unit = '';
      if (row.AlertType === 'Cost_Reduction') {
        unit = 'Dollars';
      } else if (row.AlertType === 'COF_Increase') {
        unit = 'Percentage';
      }
      return { ...row, Unit: unit };
    });
    const combinedData = [...augmentedData, ...editThresholdAlertsData];
    return combinedData.filter((row) => {
      const lowerSearchQuery = searchQuery.toLowerCase();
      return (
        row.EntityType?.toLowerCase().includes(lowerSearchQuery) ||
        row.Name?.toString().toLowerCase().includes(lowerSearchQuery) ||
        row.AlertType?.toLowerCase().includes(lowerSearchQuery) ||
        row.Threshold?.toString().toLowerCase().includes(lowerSearchQuery) ||
        (row.Unit && row.Unit?.toLowerCase().includes(lowerSearchQuery))
      );
    });
  }, [fileData, editThresholdAlertsData, searchQuery]);

  const handleSave = () => {
    updateThresholdValues(updatedRowsWithThresholdValues);
    setUnsavedChanges(true);
  };

  const handleClickRowChange = (updatedValues) => {
    setUpdatedRowsWithThresholdValues(updatedValues);
    setUnsavedChanges(false);
  };

  const handleClickBulkEdit = useCallback(() => {
    handleBulkEdit();
  }, [handleBulkEdit]);

  const handleClearSearch = useCallback(() => {
    setSearchTerm('');
    setSearchQuery('');
  }, []);

  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);
    setSearchTerm(event.target.value);
  }, []);

  return (
    <BootstrapDialog
      onClose={handleEditClose}
      aria-labelledby="customized-dialog-title"
      open={openEdit}
    >
      <DialogTitle sx={{ m: 0, padding: "10px 20px 0px 35px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography style={{ fontSize: "15px", fontWeight: "600" }}>
          {fileData.length ? "View Threshold for Alerts" : "Edit Threshold for Alerts"}
        </Typography>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ display: 'flex', alignItems: 'center', margin: "0px 20px" }}>
            <TextField
              hiddenLabel
              id="search-input"
              placeholder='Search'
              value={searchTerm}
              onChange={handleSearchChange}
              variant="outlined"
              size="small"
              sx={{
                width: '400px',
                '& .MuiInputBase-input': {
                  height: '15px',
                  borderRadius: "20px",
                  fontSize: "12px",
                  borderColor: 'transparent',
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchTerm ? (
                      <IconButton
                        aria-label="clear search"
                        onClick={handleClearSearch}
                        size="small"
                      >
                        <CloseIcon fontSize="small" style={{ color: "#d1d0d0" }} />
                      </IconButton>
                    ) : (
                      <SearchIcon fontSize="small" style={{ color: "#d1d0d0" }} />
                    )}
                  </InputAdornment>
                ),
              }}
            />
          </div>
          {!fileData.length > 0 && (
            <>
              <Button
                variant="text"
                size="small"
                sx={{ fontSize: "14px", marginRight: "10px", textTransform: 'none', color: "#2B5692" }}
                onClick={handleClickBulkEdit}
              >
                Bulk Edit
              </Button>
              <Button variant="contained" disabled={unsavedChanges} size="small" onClick={handleSave} sx={{ fontSize: "12px", textTransform: 'none', background: "#2B5692" }}>
                Save
              </Button>
            </>
          )}
          <IconButton
            aria-label="close"
            onClick={handleEditClose}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        {editAlertLoading ? (
          <div className={classes.loader}>
            <Loading />
          </div>
        ) : (
          <EditTable filteredRows={filteredRows} handleSave={handleSave} handleClickRowChange={handleClickRowChange} fileData={fileData} />
        )}
      </DialogContent>
    </BootstrapDialog>
  );
};
const mapStateToProps = state => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  periodType: state.filter.periodType,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
});

export default connect(mapStateToProps)(EditAlerts);
